import styled from "styled-components";

export const Styles = styled.div`
  flex: 1;
  order: 2;
  width: 100%;

  @media (max-width: 992px) {
    &.detail-summary-column {
      flex: 1 1 100%;
      max-width: none;
    }
  }

  .title {
    color: var(--color-item);
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .container-summary {
    display: flex;
    gap: 11px;
    .summary-item {
      background: var(--bg-item);
      display: flex;
      padding: 12px;
      flex: 1;
      gap: 12px;
      border-radius: 8px;
      .title {
        font-size: 12px;
        font-weight: 400;
        color: #d9d9d9;

        .desktop & {
          color: #00000073;
        }
      }
      .text-info {
        font-size: 16px;
        font-weight: 700;
      }
      .icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        &.time_start {
          background: #6a8dff;
        }
        &.time_break {
          background: #fdb73b;
        }
      }
    }
  }

  .container-status {
    border-radius: 8px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--bg-item);

    > span:first-child {
      color: var(--color-item);
      font-size: 14px;
    }
  }
`;
